import {
	AdditionalServicesFragment,
	GdsService_OrderAdditionalServiceGdsServiceVip_Fragment,
	GdsServiceVipSubType,
	OrderAdditionalServiceGdsServiceServiceType
} from '@websky/graphql';

export const getEXSTServices = (services: AdditionalServicesFragment['gdsServices']['services']) =>
	services.filter(
		service =>
			service.rfisc === 'EXST' &&
			service.type === OrderAdditionalServiceGdsServiceServiceType.Vip &&
			(service as GdsService_OrderAdditionalServiceGdsServiceVip_Fragment)?.subType ===
				GdsServiceVipSubType.ExtraSeat
	) as GdsService_OrderAdditionalServiceGdsServiceVip_Fragment[];
